import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../app/store";
import * as service from "../../../services/supplierDealing";
import { SupplierDealingParams } from "../../../services/supplierDealing";
interface SupplierDealing {
  SupplierDealing: [],
  Total: 0,
  Current: 1,
}

const initialState: SupplierDealing = {
  SupplierDealing: [],
  Total: 0,
  Current: 1,
};

const supplierDealingSlice = createSlice({
  name: "supplierDealingSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.SupplierDealing = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
  },
});

export const {setData, 
  setTotal,
  setCurrent, } = supplierDealingSlice.actions;


  export const selectSupplierDealingData = (state: RootState) =>
  state.supplierDealing.SupplierDealing;
  export const selectTotal = (state: RootState) => state.supplierDealing.Total
  
  export const selectCurrent = (state: RootState) => state.supplierDealing.Current
  
  

export function getSupplierDealingList(params: SupplierDealingParams): RootThunk {
  return api(service.getSupplierDealing(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}


export default supplierDealingSlice.reducer;
